export default __webpack_public_path__ + "static/media/Ballroll_00348.8bb8a928.png";